import { HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbpHttpInterceptor } from 'abp-ng2-module';

@Injectable()
export class SironaHttpInterceptor extends AbpHttpInterceptor {

    static urlsToSkipRequestHeaderNormalization: string[] = [];

    protected normalizeRequestHeaders(request: HttpRequest<any>): HttpRequest<any> {
        if (SironaHttpInterceptor.urlsToSkipRequestHeaderNormalization.some(x => x === request.url)) {
            return request;
        }

        return super.normalizeRequestHeaders(request);
    };
};
